import { Link } from 'react-router-dom';
import { breakingFeed } from '@/mocks/ranking';

const levelMap: Record<string, { label: string; className: string }> = {
  urgent: { label: '紧急', className: 'bg-primary-500 text-background-50' },
  focus: { label: '重点关注', className: 'bg-accent-500 text-background-50' },
  follow: { label: '跟进中', className: 'bg-secondary-200 text-secondary-900' },
};

export default function BreakingTimeline() {
  return (
    <section className="border-b border-background-200 bg-background-50 py-12 md:py-16" aria-labelledby="timeline-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-time-line text-sm" />
              </span>
              事件推进中
            </span>
            <h2 id="timeline-heading" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今晚突发时间线
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              把正在推进的事件按时间顺序排好，点开任意一条就能看到完整的节点记录与最新进展，不用再翻聊天记录找前情。
            </p>
            <Link
              to="/breaking"
              className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看全部突发新闻
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-5 md:pl-6">
              {breakingFeed.slice(0, 6).map((item) => {
                const meta = levelMap[item.level] ?? levelMap.follow;
                return (
                  <li key={item.id} className="relative pb-6 last:pb-0">
                    <span className="absolute -left-[27px] top-1.5 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-50 bg-primary-400 md:-left-[31px]" />
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-heading text-sm font-bold text-foreground-950">{item.time}</span>
                      <span className={`rounded-full px-2 py-0.5 text-[11px] ${meta.className}`}>{meta.label}</span>
                    </div>
                    <Link
                      to={`/topic/${item.slug}`}
                      className="mt-1.5 block cursor-pointer text-sm leading-relaxed text-foreground-800 transition-colors hover:text-primary-700 md:text-base"
                    >
                      {item.title}
                    </Link>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}